import Vue from 'vue';
import moment from 'moment';
import store from '../store/store';
import { convertCentimetersToImperialUnits, convertKilosToImperialUnits } from 'braster-frontend-utils';

const getUserTerritory = () => store.state.user.units[0].territory;
const getUserMeasurementSystem = () => getUserTerritory().measurementSystem.name;
const getUser = () => store.state.user;
export const calculateBMI = (weight, height) => ((weight * 10000) / (height * height)).toFixed(2);

const roundTo2DecimalPlaces = value => Math.round(value * 100) / 100;
export const convertFtAndInchesToCentimeters = (ft, inches) => {
    const centimeters = ft * 30.48 + inches * 2.54;
    return roundTo2DecimalPlaces(centimeters);
};
export const convertLbAndOzToKilos = (lb, oz) => {
    const centimeters = lb * 0.45359237 + oz * 0.0283495231;
    return roundTo2DecimalPlaces(centimeters);
};

export const METRIC = 'METRIC';
export const IMPERIAL = 'IMPERIAL';

Object.defineProperties(Vue.prototype, {
    userTerritory: {
        get: getUserTerritory,
    },
    dateFormat: {
        get: () => date => {
            const dateMask = getUser().dateFormat.toUpperCase();
            return date ? moment(date).format(dateMask) : '';
        },
    },
    heightFormat: {
        get: () => centimetersHeight => {
            const measurementSystem = getUserMeasurementSystem();
            if (measurementSystem === IMPERIAL) {
                const { ft, inches } = convertCentimetersToImperialUnits(centimetersHeight);
                return `${ft}′ ${inches}″`;
            } else if (measurementSystem === METRIC) {
                return `${centimetersHeight} cm`;
            } else {
                return '';
            }
        },
    },
    weightFormat: {
        get: () => kiloWeight => {
            const measurementSystem = getUserMeasurementSystem();
            if (measurementSystem === IMPERIAL) {
                const { lb, oz } = convertKilosToImperialUnits(kiloWeight);
                return `${lb} lb ${oz} oz`;
            } else if (measurementSystem === METRIC) {
                return `${kiloWeight} kg`;
            } else {
                return '';
            }
        },
    },
    decimalSeparator: {
        get: () => text => {
            const decimalSeparator = getUser().decimalSeparatorSymbol;
            const decimalSeparatorRegex = /\./g;
            return `${text}`.replace(decimalSeparatorRegex, decimalSeparator);
        },
    },
    thousandsSeparator: {
        get: () => text => {
            const thousandsSeparator = getUser().thousandSeparatorSymbol;
            const thousandsSeparatorRegex = /\B(?=(\d{3})+(?!\d))/g;
            return `${text}`.replace(thousandsSeparatorRegex, thousandsSeparator);
        },
    },
});



// WEBPACK FOOTER //
// ./src/plugins/customSettings.js